import { ErrorState } from "components/ErrorState";
import { Layout } from "components/Layout";

interface Props {
  error: Error;
}

const ErrorFallbackPage: React.FC<Props> = ({ error }) => {
  return (
    <Layout title="" tooltips={[]} plain>
      <ErrorState
        errorCode={500}
        title="Something went wrong"
        description="An unexpected error occurred. Please try again or contact support if the problem persists."
        errorDetails={error.message || "An unexpected error occurred."}
        onGoHome={() => {
          window.location.href = "/dashboard";
        }}
      />
    </Layout>
  );
};

export default ErrorFallbackPage;
